import { render } from "./SendWebhook.vue?vue&type=template&id=860fdbfe"
import script from "./SendWebhook.vue?vue&type=script&lang=js"
export * from "./SendWebhook.vue?vue&type=script&lang=js"
script.render = render

export default script